import React, { Component } from 'react'
import loader from 'assets/images/loader.svg'

class Loader extends Component {

    render() {
        return (
            <div className={this.props.noPage ? "text-center loader" : "text-center loader loader-page"}> 
                <img alt="LOADER" src={loader} />
                <p>CARREGANDO ...</p>                
            </div>
        )
    }
}

export default Loader